jQuery(function($){
	$('.purchase-button.arrangement a.authorized-download').on('click', function(e){
		e.preventDefault();

		if(!$(this).closest('.purchase-button').hasClass('check-voicing')) {
			$('.popup-cart').removeClass('showing');

			const voicing = $(this).attr('voicing');
			const voicingTitle = $(this).attr('voicing_title');
			const songTitle = decodeURIComponent(atob($(this).attr('song_title')));
			const songId = $(this).attr('song_id');

			const modalWrapper = $('#authorized-download-modal-wrapper');

			if($('.store-layout-overlay.visible').length) $('.store-layout-overlay').removeClass('visible');
			if($('.store-item.showing').length) $('.store-item').removeClass('showing');
			if($('.more-info-trigger.showing').length) $('.more-info-trigger').removeClass('showing');

			modalWrapper.find('.arrangement-modal-song-title span.song-title').html(songTitle);
			modalWrapper.find('.arrangement-modal-voicing span.voicing-title').html(voicingTitle);

			modalWrapper.find('.arrangement-modal-body input[name="song_id"]').val(songId);
			modalWrapper.find('.arrangement-modal-body input[name="voicing"]').val(voicing);
			modalWrapper.find('.arrangement-modal-body input[name="voicing_title"]').val(voicingTitle);

			modalWrapper.find('.arrangement-modal-background').addClass('visible');
			modalWrapper.find('.arrangement-modal').addClass('showing');

			console.log(voicing, voicingTitle, songTitle, songId);
		}
	});

	$('form.authorized-download-form').on('submit', function(e){
		const el = $(this);

	    let isFormValid = el[0].checkValidity();
	    if(!isFormValid) {
	        el[0].reportValidity();
	        return;
	    }

		e.preventDefault();

		data = {};
		$.each(el.serializeArray(), function(i, field){
			data[field.name] = field.value;
		});

		console.log(data);

		const confirmedFields = [
			'song_id',
			'voicing',
			'voicing_title',
		];

		let fieldsConfirmed = true;
		$.each(confirmedFields, function(index, field){
			console.log(index, field, data[field], data[field].length);
			if(!data[field].length) fieldsConfirmed = false;
		});

		if(fieldsConfirmed) {
			el.find('input[type="submit"]').hide().after('<div class="loading-arrangement-modal"><span class="fas fa-cog fa-spin"></span> Creating Authorized Download</div>');

			$.post('/wp-admin/admin-ajax.php', data, function(cartUrl){
				console.log(cartUrl);
				el.find('.loading-arrangement-modal').html('<div class="alert success" style="margin: 0"><p>Added to cart! <a href="' + cartUrl + '">View Cart</a></p></div>');
			});
		} else {
			el.find('input[type="submit"]').hide().after('<div class="loading-arrangement-modal"><span class="fas fa-cog fa-spin"></span> Creating Authorized Download</div>');
			setTimeout(function(){
				el.find('.loading-arrangement-modal').html('<div class="alert danger" style="margin: 0"><p>Error creating authorized download.</p></div>');
			}, 1000);
		}
	});
});